import Box from '@mui/material/Box'
import { useMe } from '../../hooks/me'
import { Chip } from '@mui/material'
import { Trans } from 'react-i18next'
import { SessionAccountTypeEnum } from '../../generated/graphql'

export const EnvironmentIndicator = () => {
  const { me } = useMe()
  const accountType = me?.accountType

  if (accountType === SessionAccountTypeEnum.Production) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        paddingX: (theme) => theme.spacing(2),
        background: (theme) =>
          accountType === SessionAccountTypeEnum.Test
            ? undefined
            : theme.palette.yellow.main,
      }}
    >
      <Trans
        i18nKey="shared:environment_indicator_label"
        components={{
          chip: (
            <Chip
              sx={{ mx: 0.5 }}
              label={accountType}
              size="small"
              color="black"
            />
          ),
        }}
      />
    </Box>
  )
}
